var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlame = function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8864 1.91847C11.8594 1.34946 11.388 0.877792 10.839 1.0298C10.4818 1.12869 10.1334 1.27399 9.8015 1.46571C6.59155 3.32015 1 7.47775 1 13.9385C1 20.1943 5.92485 23.0003 12 23.0003C18.0751 23.0003 23 20.1943 23 13.9385C23 9.23935 20.042 5.75865 17.1938 3.49635C16.6404 3.05679 15.8389 3.36649 15.6057 4.03364C15.3159 4.86273 14.931 5.63895 14.4262 6.12085C14.0082 6.51985 13.3487 6.4063 13 5.9455C12.2233 4.91913 11.9533 3.32682 11.8864 1.91847ZM11.6366 11.6659C11.867 11.5527 12.1329 11.5527 12.3634 11.6659C13.3492 12.1503 16 13.695 16 16.3C16 18.5091 14.2092 19.5 12 19.5C9.79085 19.5 8 18.5091 8 16.3C8 13.695 10.6508 12.1503 11.6366 11.6659Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3634 11.666C12.133 11.5527 11.867 11.5527 11.6366 11.666C10.6508 12.1503 8 13.695 8 16.3C8 18.5092 9.79085 19.5 12 19.5C14.2092 19.5 16 18.5092 16 16.3C16 13.695 13.3492 12.1503 12.3634 11.666Z",
    fill: "#64748B"
  })));
};
export default SvgFlame;